/**
 * 选项场景：SFX/BGM 音量（←→ 10% 步进，即时生效（音量持久化 localStorage；静音仅内存，刷新不保留））+ 静音开关。
 * 音量改动立即播放 cursor 音效（用户可即时听到 SFX 音量效果）。
 */
import { VIEW_W, VIEW_H } from '../config.js';
import { Input } from '../engine/input.js';
import { cycleIndex, menuNav } from '../engine/menu.js';
import { t, getLang, setLang, LANGS, LANG_NAMES } from '../i18n.js';

const BAR_W = 160;

export const OptionsScene = {
  mgr: null,

  enter() {
    this.idx = 0;
    this.rows = ['sfx', 'bgm', 'lang', 'mute'];
  },

  exit() {},

  _audio() {
    return this.mgr.shared.audio;
  },

  _vol(key) {
    const a = this._audio();
    return key === 'sfx' ? a.getSfxVolume() : a.getBgmVolume();
  },

  _setVol(key, v) {
    const a = this._audio();
    if (key === 'sfx') a.setSfxVolume(v);
    else a.setBgmVolume(v);
  },

  update() {
    const a = this._audio();
    if (Input.pressed('cancel')) {
      a.playSfx('select');
      this.mgr.switchTo('title');
      return;
    }
    const nav = menuNav(Input, a, this.idx, this.rows.length);
    if (nav !== null) this.idx = nav;
    const row = this.rows[this.idx];
    // 不用 valueDir：cursor 音必须在换值之后播（即时试听新 SFX 音量）
    const dir = Input.pressed('left') ? -1 : Input.pressed('right') ? 1 : 0;
    if (dir !== 0) {
      let changed = true;
      if (row === 'mute') {
        a.setMuted(!a.muted);
      } else if (row === 'lang') {
        const langs = LANGS;
        setLang(langs[cycleIndex(langs.indexOf(getLang()), langs.length, dir)]);
      } else {
        const cur = this._vol(row);
        const next = Math.round((cur + dir * 0.1) * 10) / 10;
        changed = next !== cur; // 边界处值未变不播试听音（历史 bug：无新音量可试听）
        this._setVol(row, next);
      }
      if (changed) a.playSfx('cursor'); // 即时试听新 SFX 音量
      if (row === 'mute') return; // mute 行方向键处理后不再走 confirm（同帧双按双重取反的历史 bug）
    }
    if (Input.pressed('confirm')) {
      if (row === 'mute') {
        a.setMuted(!a.muted);
        a.playSfx('cursor');
      } else {
      this.mgr.switchTo('title');
      }
    }
  },

  _bar(r, x, y, frac, color) {
    r.rect(x, y, BAR_W, 8, { fill: '#223', stroke: '#557' });
    r.rect(x, y, BAR_W * Math.max(0, Math.min(1, frac)), 8, { fill: color });
  },

  draw(r) {
    const a = this._audio();
    r.rect(0, 0, VIEW_W, VIEW_H, { fill: '#001', alpha: 0.85 });
    r.text(t('opt.title'), VIEW_W / 2, 90, { size: 24, color: '#fff', align: 'center' });
    r.text(t('opt.hint'), VIEW_W / 2, 130, { size: 11, color: '#889', align: 'center' });
    const rows = [
      ['opt.sfx', this._vol('sfx'), '#4cf'],
      ['opt.bgm', this._vol('bgm'), '#8f8'],
      ['opt.lang', null, '#c9f'],
      ['opt.mute', a.muted ? 0 : 1, '#fc3'],
    ];
    for (let i = 0; i < rows.length; i++) {
      const y = 200 + i * 56;
      const sel = i === this.idx;
      const [label, val, color] = rows[i];
      if (sel) r.text('▶', 52, y, { size: 16, color: '#ff4' });
      r.text(t(label), 84, y, { size: 16, color: sel ? '#ff4' : '#ccd' });
      if (label === 'opt.mute') {
        r.text(a.muted ? t('opt.on') : t('opt.off'), 300, y, { size: 16, color: a.muted ? '#f66' : '#8f8' });
      } else if (label === 'opt.lang') {
        r.text(LANG_NAMES[getLang()], 300, y, { size: 16, color: '#c9f' });
      } else {
        this._bar(r, 250, y + 4, val, color);
        r.text(`${Math.round(val * 100)}%`, 250 + BAR_W + 12, y, { size: 14, color: sel ? '#fff' : '#99a' });
      }
    }
    r.text(t('opt.back'), VIEW_W / 2, VIEW_H - 60, { size: 12, color: '#889', align: 'center' });
  },
};
